import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import PopupTargetController from "./PopupTargetController" ;
import ListWrapper from "../utils/ListWrapper" ;
import SearchFilterView from "./SearchFilterView" ;
import InputFieldType from "../classes/InputFieldType" ;
import Popup from "./Popup" ;
import TextView from "./TextView" ;
import Chip from "./Chip" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import { BuildContext } from "../classes/BuildContext" ;

type _CollectionViewOnChanged < T > = ( value : Array<T> ) => void ;

type _CollectionViewOnCancel < T > = ( ) => void ;


  export  interface  CollectionViewProps < T > extends  BaseUIProps {   key?: string ;
   name: string ;
   isRequired?: boolean ;
   value: Array<T> ;
   items: Array<T> ;
   placeHolder: string ;
   errors?: Array<string> ;
   fieldType?: InputFieldType ;
   disable?: boolean ;
   _valueHash?: number ;
   _itemsHash?: number ;
   _errorsHash?: number ;
   onChanged?: _CollectionViewOnChanged<T> ;
   onCancel?: _CollectionViewOnCancel<T> ;
 }

   class  _CollectionViewState < T > extends  ObservableComponent<CollectionViewProps<T>> {   static defaultProps = { name:'', isRequired:false, placeHolder:'', fieldType:InputFieldType.Rectangle, disable:false, value:[], items:[], errors:[], onChanged:null, onCancel:null } ;
   emptyController: ui.TextEditingController = new ui.TextEditingController() ;
   internalValue: Array<T> = ListWrapper.widget(this,'internalValue') ;
   popUpWidth: number = 150.0 ;
   focused: boolean = false ;
   focusNode: ui.FocusNode = null ;
   searchValue: string = '' ;
   data: Array<T> = ListWrapper.widget(this,'data') ;
   resultsPopup: Popup ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
  public rowEmptyPopupTargetController: PopupTargetController = new PopupTargetController() ;
 public constructor ( props : CollectionViewProps<T> ) {
 super(props);

this.initState();
 }
  public get name (  ) : string {
 return this.props.name ; 
 }
  public get isRequired (  ) : boolean {
 return this.props.isRequired ; 
 }
  public get value (  ) : Array<T> {
 return this.props.value ; 
 }
  public get items (  ) : Array<T> {
 return this.props.items ; 
 }
  public get placeHolder (  ) : string {
 return this.props.placeHolder ; 
 }
  public get errors (  ) : Array<string> {
 return this.props.errors ; 
 }
  public get fieldType (  ) : InputFieldType {
 return this.props.fieldType ; 
 }
  public get disable (  ) : boolean {
 return this.props.disable ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.subscribeToList(this.value,'value');

this.on([ 'value' ],this.computeInternalValue);

this.computeInternalValue();

this.subscribeToList(this.items,'items');

this.subscribeToList(this.errors,'errors');

this.on([ 'disable', 'errors', 'fieldType', 'focusNode', 'focused', 'internalValue', 'isRequired', 'name', 'placeHolder' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : CollectionViewProps<T> ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.name !== this.props.name ) {
 this.fire('name',this);
 }

if ( prevProps.isRequired !== this.props.isRequired ) {
 this.fire('isRequired',this);
 }

if ( prevProps.value !== this.props.value ) {
 this.fire('value',this);
 }

if ( prevProps.items !== this.props.items ) {
 this.fire('items',this);
 }

if ( prevProps.placeHolder !== this.props.placeHolder ) {
 this.fire('placeHolder',this);
 }

if ( prevProps.errors !== this.props.errors ) {
 this.fire('errors',this);
 }

if ( prevProps.fieldType !== this.props.fieldType ) {
 this.fire('fieldType',this);
 }

if ( prevProps.disable !== this.props.disable ) {
 this.fire('disable',this);
 }
 }
  public setInternalValue ( val : Array<T> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.internalValue,val);

if ( !isValChanged ) {
 return ; 
 }

this.internalValue.clear();

this.internalValue.addAll(val);

this.fire('internalValue',this);
 }
  public addToInternalValue ( val : T,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.internalValue.contains(val) ) this.internalValue.add(val);
 }
 else {
 this.internalValue.remove(this.internalValue.elementAt(index));

this.internalValue.add(val);
 }

this.fire('internalValue',this,val,true);
 }
  public removeFromInternalValue ( val : T ) : void {
 this.internalValue.remove(val);

this.fire('internalValue',this,val,false);
 }
  public computeInternalValue  =  (  ) : void  =>  {
 try {
 this.setInternalValue(Array.from([ ...this.value ]));
 }
 catch ( exception ) {
 console.log(' exception in computeInternalValue : ' + exception.toString());

this.setInternalValue([  ]);
 }
 }
  public setPopUpWidth ( val : number ) : void {
 let isValChanged :boolean=this.popUpWidth !== val;

if ( !isValChanged ) {
 return ; 
 }

this.popUpWidth=val;

this.fire('popUpWidth',this);
 }
  public setFocused ( val : boolean ) : void {
 let isValChanged :boolean=this.focused !== val;

if ( !isValChanged ) {
 return ; 
 }

this.focused=val;

this.fire('focused',this);
 }
  public setFocusNode ( val : ui.FocusNode ) : void {
 let isValChanged :boolean=this.focusNode !== val;

if ( !isValChanged ) {
 return ; 
 }

this.focusNode=val;

this.fire('focusNode',this);
 }
  public setSearchValue ( val : string ) : void {
 let isValChanged :boolean=this.searchValue !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchValue=val;

this.fire('searchValue',this);
 }
  public setData ( val : Array<T> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.data,val);

if ( !isValChanged ) {
 return ; 
 }

this.data.clear();

this.data.addAll(val);

this.fire('data',this);
 }
  public addToData ( val : T,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.data.contains(val) ) this.data.add(val);
 }
 else {
 this.data.remove(this.data.elementAt(index));

this.data.add(val);
 }

this.fire('data',this,val,true);
 }
  public removeFromData ( val : T ) : void {
 this.data.remove(val);

this.fire('data',this,val,false);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ children:[ TextView({ data:this.name, className:'x3c5', key:'0' }), ((this.isRequired) ? TextView({ data:'*', className:'x5d8' }) : [  ]) ], key:'0' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, states:ui.joinStates({ 'data-c0':this.fieldType === InputFieldType.Circle && this.focused, 'data-c1':this.fieldType === InputFieldType.Circle && !this.focused, 'data-c2':this.fieldType === InputFieldType.Underline && !this.focused, 'data-c3':this.fieldType === InputFieldType.Underline && this.focused, 'data-c4':this.fieldType === InputFieldType.Rectangle && this.focused, 'data-c5':this.fieldType === InputFieldType.Rectangle && !this.focused },{}), children:[ ui.InputField({ activeColor:cStyle.c1, inActiveColor:new ui.Color(0xffd9d9d9), focusNode:this.focusNode, padding:ui.EdgeInsets.all(4.0,new Map()), disable:this.disable, placeHolder:this.placeHolder, cornerRadius:4.0, controller:this.emptyController, onChanged:( text ) => {
 this.onChangeText(text);
 }
, onTap:(  ) => {
 this.onEmptyClick();
 }
, onFocusChange:( val ) => {
  }
, className:'x8f3 hc vc h', key:'0' }) ], d3eRef:ui.LayoutAware(( bounds,globalPos ) => {
 this.onDropDownBoundsChanges(bounds,globalPos);
 }
,this.rowEmptyPopupTargetController.handleRef), className:'xb3f h', key:'1' }), ui.Column({ children:[ ui.Wrap({ spacing:5, runSpacing:5, children:[ (this.internalValue).expand(( val ) => [ Chip({ title:val.toString(), onCancel:(  ) => {
 this.onDeletePressed(val);
 }
, key:val?.toString() }) ]) ], key:'0' }) ], className:'x8c8', key:'2' }), ((this.errors.isNotEmpty) ? ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ (this.errors).expand(( item ) => [ TextView({ data:item, textAlign:cStyle.tTextViewErrorTextTextAlignOn, style:new ui.TextStyle({color:cStyle.tTextViewErrorTextColorOn}), className:'ErrorText xd96', key:item?.toString() }) ]) ] }) : [  ]) ], className:ui.join('CollectionView x0e73 h ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setFocusNode(new ui.FocusNode());

this.focusNode.addListener(this.onChangeFocus);

this.setSearchValue('');
 }
  public onEmptyClick  =  (  ) : void  =>  {
 if ( !this.disable ) {
 this.setData(this.items);

this.showResults({ autoClose:true, takeFocus:false });

this.setSearchValue('');

this.setFocused(true);
 }
 }
  public onSelectListTile  =  ( item : any ) : void  =>  {
 if ( this.onChanged !== null ) {
 if ( !this.internalValue.contains(item) ) {
 this.internalValue.add(item);
 }

this.onChanged(this.internalValue);

this.emptyController.text='';
 }

this.hideResults();

this.setFocused(false);

this.setSearchValue('');
 }
  public onDropDownBoundsChanges  =  ( bounds : ui.Rect,globalPos : ui.Offset ) : void  =>  {
 this.setPopUpWidth(bounds.width - 12);
 }
  public onDeletePressed  =  ( val : T ) : void  =>  {
 if ( this.onChanged !== null ) {
 this.internalValue.remove(val);

this.onChanged(this.internalValue);
 }

if ( this.onCancel !== null ) {
 this.onCancel();
 }
 }
  public onChangeFocus  =  (  ) : void  =>  {
 this.setFocused(this.focusNode.hasFocus);
 }
  public onChangeText  =  ( text : string ) : void  =>  {
 let val :string=text !== null ? text : '';

this.setData(this.items.where(( i ) => !this.value.contains(i)).where(( j ) => j.toString().toLowerCase().startsWith(val.toLowerCase())).toList());

if ( val !== '' || val.isNotEmpty ) {
 this.showResults({ autoClose:false, takeFocus:false });
 }
 }
  public get onChanged (  ) : _CollectionViewOnChanged<T> {
 return this.props.onChanged ; 
 }
  public get onCancel (  ) : _CollectionViewOnCancel<T> {
 return this.props.onCancel ; 
 }
  public dispose (  ) : void {
 this.resultsPopup?.dispose();

super.dispose();
 }
  public showResults ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.resultsPopup ?. dispose();

let target :ui.Rect=this.rowEmptyPopupTargetController.getTarget(this.context);

this.resultsPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Bottom,child:ui.Container({ height:200, width:this.popUpWidth, child:SearchFilterView({ items:this.data, onSelectItem:( item ) => {
 this.onSelectListTile(item);
 }
 }), className:'xfde hc vc' }),target:target});

this.resultsPopup.showPopup(this.context);
 }
  public hideResults (  ) : void {
 this.resultsPopup ?. dispose();
 }
 }
export default function CollectionView <T> ( props : CollectionViewProps<T> ) {
 return React.createElement(_CollectionViewState<T>,{ ..._CollectionViewState.defaultProps, ...props },ListWrapper.fromInput<T>(props.value,'value'),ListWrapper.fromInput<T>(props.items,'items'),ListWrapper.fromInput<string>(props.errors,'errors')) ; 
 }
